import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import Vue from 'vue';
import VueRouter from 'vue-router';
import layoutHeaderAside from '@/layout/header-aside';
import { Message, MessageBox } from 'element-ui'; // 进度条

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '@/store/index';
import util from '@/libs/util.js'; // 路由数据

import routes from './routes'; // fix vue-router NavigationDuplicated

var VueRouterPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch(function (err) {
    return err;
  });
};

var VueRouterReplace = VueRouter.prototype.replace;

VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch(function (err) {
    return err;
  });
}; // 固定菜单与路由


import { menuAside, menuHeader } from '@/menu';
import { frameInRoutes } from '@/router/routes';

var _import = require('@/libs/util.import.' + process.env.NODE_ENV); //模拟动态菜单与路由
// import { permissionMenu, permissionRouter } from '@/mock/permissionMenuAndRouter'
//代码生成器生成的菜单与路由


import autoGenerateMenusAndRouters from '@/development';
Vue.use(VueRouter); // 导出路由 在 main.js 里使用

var router = new VueRouter({
  routes: routes
});
var permissionMenu,
    permissionRouter = [];
var permission = {
  functions: [],
  roles: [],
  isAdmin: false
}; //标记是否已经拉取权限信息

var isFetchPermissionInfo = false; // (resolve) => require([`@/views${route.url}`], resolve)

var fetchPermissionInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var formatRoutes, list, accessMenusList, accessMenus, allMenuAside, allMenuHeader;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            //处理动态添加的路由
            formatRoutes = function formatRoutes(routes) {
              routes.forEach(function (route) {
                route.component = route.url == "" ? layoutHeaderAside : _import(route.url.slice(1));
                route.path = route.url;
                var paths = route.path ? route.path.split('/') : null;
                route.name = paths ? paths[paths.length - 1] : '';
                route.meta = {
                  title: route.title,
                  scrollTop: 0,
                  scrollLeft: 0,
                  cache: true
                };
                route.children = route.son_menu || [];

                if (route.son_menu.length) {
                  formatRoutes(route.son_menu);
                }
              });
            };

            list = window.localStorage.getItem('Menu') ? JSON.parse(window.localStorage.getItem('Menu')) : [];
            permissionRouter = [].concat(_toConsumableArray(list), _toConsumableArray(autoGenerateMenusAndRouters.routers)); // let isLargeScreenData = store.dispatch('d2admin/db/get', {
            //   dbName: 'sys',
            //   path: 'user.islargeScreenData',
            //   defaultValue: false,
            //   user: true
            // }, {
            //   root: true
            // })

            _context.next = 5;
            return store.dispatch('d2admin/db/get', {
              dbName: 'sys',
              path: 'menu.accessMenus',
              defaultValue: [],
              user: true
            }, {
              root: true
            });

          case 5:
            accessMenusList = _context.sent;
            accessMenus = accessMenusList;
            allMenuAside = [].concat(_toConsumableArray(menuAside), _toConsumableArray(accessMenus));
            allMenuHeader = [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenus));
            formatRoutes(list); //动态添加路由

            router.addRoutes(list); // 处理路由 得到每一级的路由设置

            store.commit('d2admin/page/init', [].concat(_toConsumableArray(frameInRoutes), _toConsumableArray(permissionRouter))); // 设置顶栏菜单

            store.commit('d2admin/menu/headerSet', allMenuHeader); // 设置侧边栏菜单

            store.commit('d2admin/menu/asideSet', allMenuAside); // 初始化菜单搜索功能

            store.commit('d2admin/search/init', allMenuHeader); // 加载上次退出时的多页列表

            store.dispatch('d2admin/page/openedLoad');
            _context.next = 18;
            return Promise.resolve();

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchPermissionInfo() {
    return _ref.apply(this, arguments);
  };
}(); //免校验token白名单


var whiteList = ['/login'];
/**
 * 路由拦截
 * 权限验证
 */

router.beforeEach( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(to, from, next) {
    var isLogin, token, proList, state, GMauthority, useryjenv, content, scrollTop;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return store.dispatch('d2admin/db/get', {
              dbName: 'sys',
              path: 'user.info.isLogin',
              defaultValue: false,
              user: true
            }, {
              root: true
            });

          case 2:
            isLogin = _context2.sent;
            // 进度条
            NProgress.start(); // 关闭搜索面板

            store.commit('d2admin/search/set', false);
            token = util.cookies.get('token');

            if (!(whiteList.indexOf(to.path) === -1)) {
              _context2.next = 30;
              break;
            }

            if (!(token && token !== undefined)) {
              _context2.next = 26;
              break;
            }

            proList = ['consumptionAnalysis', 'onlineDuration', 'orderDisplay', 'outputAnalysis', 'serverDimensionData', 'onlineDetails']; //拉取权限信息

            state = store.state.d2admin.permission.isFetchPermissionInfo;
            _context2.next = 12;
            return store.dispatch('d2admin/db/get', {
              dbName: 'sys',
              path: 'user.GMauthority',
              defaultValue: [],
              user: true
            }, {
              root: true
            });

          case 12:
            GMauthority = _context2.sent;
            _context2.next = 15;
            return store.dispatch('d2admin/db/get', {
              dbName: 'sys',
              path: 'user.useryjenv',
              defaultValue: [],
              user: true
            }, {
              root: true
            });

          case 15:
            useryjenv = _context2.sent;

            if (state) {
              _context2.next = 23;
              break;
            }

            _context2.next = 19;
            return fetchPermissionInfo();

          case 19:
            store.commit('d2admin/permission/setFet', true);
            next(to.path, true);
            _context2.next = 24;
            break;

          case 23:
            if (!window.localStorage.getItem('Menu') || !isLogin) {
              Message.error('登录已失效,请重新登录');
              store.dispatch('d2admin/account/logout');
              next(false);
            } else if ((to.path.includes('datalist') || to.path.includes('dataPirate') || to.path.includes('financial') || to.path.includes('gmTool') || to.path.includes('gmToolNew') || to.path == "/largeScreenData") && !store.state.d2admin.serchSelect.rawData.game_id) {
              if (store.state.d2admin.serchSelect.HomePageState == 2) {
                Message.error('请设置功能菜单和游戏'); // 清除侧边栏设置

                store.dispatch('d2admin/db/set', {
                  dbName: 'sys',
                  path: 'menu.accessMenus',
                  value: [],
                  user: true
                }, {
                  root: true
                }); // 清除侧边栏菜单

                store.commit('d2admin/menu/asideSet', []);
                store.dispatch('d2admin/db/set', {
                  dbName: 'sys',
                  path: 'menu.Settings',
                  value: false,
                  user: true
                }, {
                  root: true
                });
              } else {
                Message.error('请设置游戏');
                store.dispatch('d2admin/serchSelect/setPageStatus', 1);
              }

              next('/index');
            } else if (store.state.d2admin.system.kamitakuAuthorityList.findIndex(function (i) {
              return i == to.path;
            }) > -1 && store.state.d2admin.system.isAuthority) {
              // 上宅页面拦截暂时不用 kamitakuAuthorityList
              if (!store.state.d2admin.serchSelect.kamitakuSearchData.game || !store.state.d2admin.serchSelect.kamitakuSearchData.game && store.state.d2admin.user.game_show_type == 1) {
                Message.error('请选择产品');
                store.dispatch('d2admin/serchSelect/setPageStatus', 3);
                store.commit('d2admin/system/setUnskipRoute', to.path);
                next('/index');
              } else {
                next();
              }
            } else if (!GMauthority.length && to.path.includes('gmTool/')) {
              // 海盗必须有环境权限才能进入
              Message.error('没有海盗环境权限，请联系管理员');
              next(false);
            } else if (!useryjenv.length && to.path.includes('gmToolNew/')) {
              Message.error('没有御剑环境权限，请联系管理员');
              next(false);
            } else if (!useryjenv.length && proList.findIndex(function (i) {
              return i == to.name;
            }) > -1 && store.state.d2admin.serchSelect.rawData.game_mark.indexOf('yjfm') > -1) {
              Message.error('没有御剑环境权限，请联系管理员');
              next(false);
            } else if (process.env.VUE_APP_EXPORTATION == 'datacenter_web_us' && store.state.d2admin.serchSelect.rawData.game_mark.indexOf('royalpirate') == -1 && to.path.includes('gmTool/')) {
              Message.error('请设置海盗相关游戏!');
              next(false);
            } else if (process.env.VUE_APP_EXPORTATION != 'datacenter_web_us' && store.state.d2admin.serchSelect.rawData.game_mark.indexOf('royalpirates') == -1 && to.path.includes('gmTool/')) {
              Message.error('请设置海盗相关游戏!');
              next(false);
            } else if (store.state.d2admin.serchSelect.rawData.game_mark.indexOf('yjfm') == -1 && to.path.includes('gmToolNew/')) {
              Message.error('请设置御剑相关游戏!');
              next(false);
            } else {
              next();
            }

          case 24:
            _context2.next = 28;
            break;

          case 26:
            // 将当前预计打开的页面完整地址临时存储 登录后继续跳转
            // 这个 cookie(redirect) 会在登录后自动删除
            util.cookies.set('redirect', to.fullPath); // 没有登录的时候跳转到登录界面

            next({
              name: 'login'
            });

          case 28:
            _context2.next = 31;
            break;

          case 30:
            if (to.name === 'login') {
              // 如果已经登录，则直接进入系统
              if (token && token !== undefined) {
                next(from.path, true);
              } else {
                next();
              }
            } else {
              next();
            }

          case 31:
            if (from.meta.cache) {
              content = document.querySelector('.d2-container-full__body');
              scrollTop = content ? content.scrollTop : 0;
              from.meta.scrollTop = scrollTop;
            }

            NProgress.done();

          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}());
router.afterEach(function (to) {
  // 进度条
  NProgress.done(); // 需要的信息
  // const app = router.app
  // const { name, params, query } = to
  // 多页控制 打开新的页面

  store.dispatch('d2admin/page/open', to); // 更改标题

  util.title(to.meta.title);

  if (to.path !== '/index') {
    var index = store.state.d2admin.system.rebound.findIndex(function (i) {
      return i == to.path;
    });
    store.commit('d2admin/system/setCurrentRouter', index > -1 ? to.path : '');
  }
});
export default router;